import {createNavItem, ODIcons} from '@mdpp/od-react-belt'
import {SiteUrls} from '../SiteUrls'

export const getHanmiManagerSiteNavs = () => {
  return {
    items: [
      createNavItem(ODIcons.Dashboard, `대시보드`, SiteUrls.HanmiManager.Dashboard.Main),
    ],
  }
}
